import { HAS_WINDOW } from '@eb/feature-detection';
import { PRIORITY_COLLECTIONS, TABS_CONFIG } from '../../constants/tabConfig';
export const collectionInfoLookup = ({ bucketsContent }) =>
    bucketsContent.map(
        ({
            imageLarge,
            name,
            eventCount,
            id,
            displayCreatorName,
            creator,
            summary,
            creatorImageIdOverrideUrl,
        }) => ({
            imageLarge,
            name,
            eventCount,
            id,
            displayCreatorName,
            creator,
            summary,
            creatorImageIdOverrideUrl,
        }),
    );

export const orderCollections = ({ collections }) => {
    if (
        collections &&
        typeof collections === 'object' &&
        !Array.isArray(collections)
    ) {
        let orderedCollections = {};
        PRIORITY_COLLECTIONS.forEach((key) => {
            if (key in collections && !(key in orderedCollections)) {
                orderedCollections[key] = collections[key];
            }
        });
        orderedCollections = { ...orderedCollections, ...collections };

        return orderedCollections;
    } else {
        return collections;
    }
};

export const filterCollections = ({ collections = [] }) => {
    let filteredCollections = collections;

    if (HAS_WINDOW) {
        const tld = window.__SERVER_DATA__.env.localeInfo.tld;

        const correctTldCollections = !!TABS_CONFIG.all.collections[tld]
            ? Object.values(TABS_CONFIG.all.collections[tld])[0]
            : null;

        if (correctTldCollections) {
            filteredCollections = collections.filter((collection) => {
                // if the collection's `id` is in correctTldCollections will return truthy and so keep the value

                return correctTldCollections.includes(collection.id);
            });

            // Sorts the collections in case any of them have priority over the others

            let orderedCollections = [];
            PRIORITY_COLLECTIONS.forEach((key) => {
                for (const collection of filteredCollections) {
                    if (key === collection.id) {
                        orderedCollections.push(collection);
                        break;
                    }
                }
            });

            filteredCollections = filteredCollections.filter((collection) => {
                return !PRIORITY_COLLECTIONS.includes(collection.id);
            });

            orderedCollections = [
                ...orderedCollections,
                ...filteredCollections,
            ];

            return orderedCollections;
        }
    }

    return [];
};
